import { render, staticRenderFns } from "./GuestWizardNewDocumentEditView.vue?vue&type=template&id=570fbe38&scoped=true&"
import script from "./GuestWizardNewDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./GuestWizardNewDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./GuestWizardNewDocumentEditView.vue?vue&type=style&index=0&id=570fbe38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570fbe38",
  null
  
)

export default component.exports